// extracted by mini-css-extract-plugin
export default {"impactScoreIcons":"lbTqW1b6","impactScoreIconHigh":"hQ8xu5NE","impactScoreIconModerate":"xP9Vec31","impactScoreIconLight":"DtcDDAQR","impactScoreIconQuasiNull":"wv5NIiPe"};